import laptopHappyFace from './laptop-happy-face.png'
import './FullscreenError.css'

function FullscreenError({ width = '192', height = '111', message }) {
  return (
    <div className="fullscreen-error-container">
      <img
        className="error-image"
        alt="laptop-happy-face"
        width={width}
        height={height}
        src={laptopHappyFace}
      />
      <p className="error-message">{message}</p>
    </div>
  )
}

export default FullscreenError
